import { ThemeOptions, createTheme } from '@mui/material/styles'
import { keyframes } from 'tss-react'
import FlexHireTheme from 'FlexHireTheme'

const landingThemeOptions: ThemeOptions = {
  typography: {
    h1: {
      fontWeight: 500,
      letterSpacing: '1px',
      fontSize: '48px',
      '@media (max-width: 600px)': {
        fontSize: '32px',
      },
    },
    h2: {
      fontWeight: 500,
      fontSize: '34px',
      '@media (max-width: 600px)': {
        fontSize: '24px',
      },
    },
    h4: {
      '@media (max-width: 600px)': {
        fontSize: '14px',
      },
    },
    body1: {
      fontSize: '16px',
      color: '#444053',
      '@media (max-width: 600px)': {
        fontSize: '14px',
      },
    },
    subtitle1: {
      fontSize: '16px',
      letterSpacing: '1px',
      '@media (max-width: 600px)': {
        letterSpacing: 0,
        fontSize: '14px',
      },
    },
    subtitle2: {
      fontSize: '16px',
      letterSpacing: '1px',
      '@media (max-width: 600px)': {
        letterSpacing: 0,
        fontSize: '14px',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          transformOrigin: 'center top',
          animation: `${keyframes`
            from {
              opacity: 0,
              transform: scale(0),
            }
            to {
              opacity: 1,
              transform: scale(1),
            }
          `} 0.6s cubic-bezier(1, 0, 0, 1) 0.5s backwards`,
          height: '40px !important',
          fontSize: '16px !important',
          '&::before': {
            content: '""',
            display: 'inline-block',
            width: 12,
          },
          '&::after': {
            content: '""',
            display: 'inline-block',
            width: 12,
          },
          '@media (max-width: 600px)': {
            height: '40px !important',
            fontSize: '14px !important',
            '&::before': {
              width: 6,
            },
            '&::after': {
              width: 6,
            },
          },
        },
        sizeLarge: {
          height: '60px !important',
          '@media (max-width: 600px)': {
            height: '48px !important',
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          padding: '24px 12px',
          borderRadius: 9999,
          fontSize: '16px !important',
          '@media (max-width: 600px)': {
            fontSize: '14px !important',
            padding: '12px 6px',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '16px !important',
          '@media (max-width: 600px)': {
            fontSize: '14px !important',
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: 'separate',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableRow-root': {
            background: 'none !important',
          },
          '& .MuiTableCell-root': {
            borderBottom: '2px solid #E0E9F2 !important',
          },
          '& .MuiTableCell-root, & .MuiTableCell-root *': {
            fontWeight: '500 !important',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(2n + 1)': {
            background: '#F3F7FB',
          },
        },
        head: {
          background: 'none',
        },
        footer: {
          background: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '2px solid #E0E9F2 !important',
          padding: 24,
          fontSize: '16px !important', // need to override TableHead priority rules
          color: '#444053',
          '@media (max-width: 600px)': {
            fontSize: '14px !important',
            padding: 12,
          },
        },
      },
    },
    MuiListItemText: {
      defaultProps: {
        primaryTypographyProps: {
          variant: 'body1',
        },
      },
    },
  },
}

const theme = createTheme(FlexHireTheme, landingThemeOptions)

export default theme
